document.addEventListener('DOMContentLoaded', () => {
    const quantityInput = document.querySelector('.quantity-selector__input');
    const totalPriceElement = document.querySelector('#total');
    const areaElement = document.querySelector('#area');

    //debug
    if (!quantityInput || !totalPriceElement || !areaElement) {
        console.warn('Required elements not found!');
        return;
    }

    const baseArea = parseFloat(areaElement.getAttribute('data-value')); // Base area per item

    function parseDiscountRules() {
        const discountRows = document.querySelectorAll(
            '.discounty-volume-discount-widget__table tbody tr'
        );
        return Array.from(discountRows).map((row) => {
            const quantityThreshold = parseInt(
                row
                    .querySelector('.discounty-volume-discount-widget__criteria')
                    .textContent.replace('+', '')
                    .trim()
            );
            const discountRate =
                parseFloat(
                    row
                        .querySelector('.discounty-volume-discount-widget__discount')
                        .textContent.replace('% Off', '')
                        .trim()
                ) / 100;
            return { quantityThreshold, discountRate };
        });
    }

    function getApplicableDiscount(quantity, discountRules) {
        let applicableDiscount = 0;
        discountRules.forEach((rule) => {
            if (quantity >= rule.quantityThreshold) {
                applicableDiscount = rule.discountRate;
            }
        });
        return applicableDiscount;
    }

    function calculateArea(quantity) {
        return (quantity * baseArea).toFixed(2);
    }

    function updatePriceDisplay(basePrice, newTotalPrice, applicableDiscount) {
        if (applicableDiscount > 0) {
            let strikethroughPriceElement = document.querySelector('#original-price');
            if (!strikethroughPriceElement) {
                strikethroughPriceElement = document.createElement('p');
                strikethroughPriceElement.id = 'original-price';
                strikethroughPriceElement.style.textDecoration = 'line-through';
                strikethroughPriceElement.style.color = '#888';
                strikethroughPriceElement.style.marginBottom = '4px';
                totalPriceElement.parentElement.insertAdjacentElement(
                    'beforebegin',
                    strikethroughPriceElement
                );
            }

            strikethroughPriceElement.textContent = `${(
                basePrice * parseInt(quantityInput.value)
            ).toFixed(2)} €`;
        } else {
            const strikethroughPriceElement = document.querySelector('#original-price');
            if (strikethroughPriceElement) strikethroughPriceElement.remove();
        }

        let savingsMessageElement = document.querySelector('#savings-message');
        if (!savingsMessageElement) {
            savingsMessageElement = document.createElement('span');
            savingsMessageElement.id = 'savings-message';
            savingsMessageElement.style.color = 'rgb(211, 84, 0)';
            savingsMessageElement.style.fontWeight = 'bold';
            totalPriceElement.parentElement.appendChild(savingsMessageElement);
        }

        if (applicableDiscount > 0) {
            savingsMessageElement.textContent = ` Säästä ${(applicableDiscount * 100).toFixed(0)}%`;
        } else {
            savingsMessageElement.textContent = '';
        }
    }

    function roundUpToTwoDecimals(value) {
        return Math.ceil(value * 100) / 100;
    }

    function updateTotalPrice() {
        const quantity = parseInt(quantityInput.value);
        const basePrice = parseFloat(totalPriceElement.getAttribute('data-value'));

        if (isNaN(quantity) || quantity < 1) return;

        const discountRules = parseDiscountRules();
        const applicableDiscount = getApplicableDiscount(quantity, discountRules);

        const totalWithoutDiscount = basePrice * quantity;
        const newTotalPrice = roundUpToTwoDecimals(totalWithoutDiscount * (1 - applicableDiscount));

        totalPriceElement.textContent = `${newTotalPrice.toFixed(2)} €`;
        areaElement.textContent = `${calculateArea(quantity)} m2`;

        updatePriceDisplay(basePrice, newTotalPrice, applicableDiscount);
    }

    function initializeQuantitySelector() {
        console.log('Initializing quantity selector...');
        quantityInput.addEventListener('input', updateTotalPrice);
        document.querySelectorAll('.quantity-selector__button').forEach((button) => {
            button.addEventListener('click', () => {
                setTimeout(updateTotalPrice, 50);
            });
        });
        updateTotalPrice();
    }

    // UUSI LOGIIKKA: Tarkista onko alennustaulukko olemassa
    const discountTable = document.querySelector('.discounty-volume-discount-widget__table');
    
    if (discountTable) {
        // Jos alennustaulukko on jo sivulla, käynnistä heti
        console.log('Discount table found, initializing...');
        initializeQuantitySelector();
    } else {
        // Jos ei ole, odota hetki ja käynnistä ilman alennustaulukkoa
        const observer = new MutationObserver((mutationsList, observer) => {
            const table = document.querySelector('.discounty-volume-discount-widget__table');
            if (table) {
                observer.disconnect();
                console.log('Discount table loaded, initializing with discounts...');
                initializeQuantitySelector();
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });

        // Timeout: Jos 2 sekunnin kuluttua ei ole taulukkoa, käynnistä ilman sitä
        setTimeout(() => {
            if (!document.querySelector('.discounty-volume-discount-widget__table')) {
                observer.disconnect();
                console.log('No discount table found, initializing without discounts...');
                initializeQuantitySelector();
            }
        }, 2000);
    }
});